const SDK_VERSION = '7.42.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
